/**
 * Settings Page with Shared Sidebar
 */

import Sidebar from './Sidebar';
import ApplicationSettings from './ApplicationSettings';

export default function SettingsPage() {
  return (
    <div className="flex h-screen overflow-hidden bg-light-100">
      <Sidebar />
      <div className="flex-1 overflow-hidden">
        <ApplicationSettings />
      </div>
    </div>
  );
}

